var _path, _path2, _path3, _path4, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1C(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    width: "40px",
    height: "40px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f78f8f",
    d: "M6.5 61.5L6.5 31.5 0.5 31.5 0.5 26.5 11.5 26.5 11.5 61.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#c74343",
    d: "M11,27v34H7V32v-1H6H1v-4H11 M12,26H0v6h6v30h6V26L12,26z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f78f8f",
    d: "M14.5 61.5L14.5 23.5 6.5 23.5 6.5 18.5 19.5 18.5 19.5 61.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#c74343",
    d: "M19,19v42h-4V24v-1h-1H7v-4H19 M20,18H6v6h8v38h6V18L20,18z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f78f8f",
    d: "M46,61.5c-11.855,0-21.5-9.645-21.5-21.5S34.145,18.5,46,18.5c11.688,0,21.228,9.375,21.494,21 h-5.001c-0.265-8.868-7.562-16-16.493-16c-9.098,0-16.5,7.402-16.5,16.5S36.902,56.5,46,56.5h33.5v5H46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c74343",
    d: "M46,19c11.244,0,20.453,8.883,20.977,20h-4.006C62.451,30.09,55.038,23,46,23 c-9.374,0-17,7.626-17,17s7.626,17,17,17h33v4H46c-11.579,0-21-9.421-21-21S34.421,19,46,19 M46,18c-12.131,0-22,9.869-22,22 s9.869,22,22,22h34v-6H46c-8.822,0-16-7.178-16-16s7.178-16,16-16s16,7.178,16,16h6C68,27.869,58.131,18,46,18L46,18z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f78f8f",
    d: "M46,51.5c-6.341,0-11.5-5.159-11.5-11.5S39.659,28.5,46,28.5c6.173,0,11.227,4.89,11.489,11h-5.008 c-0.256-3.352-3.065-6-6.481-6c-3.584,0-6.5,2.916-6.5,6.5s2.916,6.5,6.5,6.5h33.5v5H46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c74343",
    d: "M46,29c5.729,0,10.448,4.401,10.955,10h-4.026c-0.487-3.388-3.408-6-6.929-6c-3.86,0-7,3.14-7,7 s3.14,7,7,7h33v4H46c-6.065,0-11-4.935-11-11S39.935,29,46,29 M46,28c-6.617,0-12,5.383-12,12s5.383,12,12,12h34v-6H46 c-3.309,0-6-2.691-6-6s2.691-6,6-6s6,2.691,6,6h6C58,33.383,52.617,28,46,28L46,28z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1C);
export default __webpack_public_path__ + "static/media/1c.dfd5b82880324f72cb2a70ce70ae894b.svg";
export { ForwardRef as ReactComponent };